import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import SntTooltip from "@cleanup/components/Tooltip/SntTooltip";

interface SntActionButtonProps {
  children?: React.ReactNode;
  to?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  tooltipText?: string;
  className?: string;
  classIcon?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // For rest props
}

const SntActionButton: React.FC<SntActionButtonProps> = ({
  children,
  to,
  onClick,
  tooltipText,
  className = "",
  classIcon,
  ...rest
}) => {
  return to ? (
    <Link
      {...rest}
      to={to}
      className={`btn btn-sm btn-sensolus-transparent ${className}`}
    >
      {children ? children : <i className={classIcon}></i>}
    </Link>
  ) : (
    <Button
      {...rest}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          e.stopPropagation();
          onClick(e);
        }
      }}
      variant="sensolus-transparent"
      size="sm"
      className={`${className}`}
    >
      {tooltipText ? (
        <SntTooltip
          text={tooltipText}
          icon={children ? children : <i className={classIcon}></i>}
        />
      ) : children ? (
        children
      ) : (
        <i className={classIcon}></i>
      )}
    </Button>
  );
};

export default SntActionButton;
